import { htExcelDateFromIso } from './htDateUtils';
import { formatPackingListM3 } from '../packingListPlNumberFormat';

export function formatHtQuantityTreated(v) {
  const s = formatPackingListM3(v);
  return s ? `${s} M3` : '';
}

/** Fecha tratamiento en certificado (ej. August 27, 2026). */
export function formatHtTreatmentDateDisplay(iso) {
  const d = htExcelDateFromIso(iso);
  if (!d) return '';
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export function formatHtWeightKg(v) {
  if (v == null || v === '') return '';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v).trim();
  const s = n.toLocaleString('pt-BR', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  return `${s} kg`;
}
